<template>
  <!-- paypal renewing to non-renewing conversion -->
  <div class="alert alert-warning" role="alert">
    <i class="fas fa-exclamation-triangle"></i>
    &nbsp;Your dedicated server has been removed from this order since we don't support a non renewing option at the moment. Please contact support@speedify.com so we could address your needs
  </div>
</template>
